import { render, staticRenderFns } from "./SuccessModalCustomBigger.vue?vue&type=template&id=da868f08&scoped=true"
import script from "./SuccessModalCustomBigger.vue?vue&type=script&lang=js"
export * from "./SuccessModalCustomBigger.vue?vue&type=script&lang=js"
import style0 from "./SuccessModalCustomBigger.vue?vue&type=style&index=0&id=da868f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da868f08",
  null
  
)

export default component.exports